module.exports = __webpack_public_path__ + "img/logo.35195771.png";